// DS5.7
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { ThemeContext, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiData } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import { URLS } from '@wix/da-url';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Logo from '@wix/da-ds/pkg/Logo';
import FooterCopyright from './FooterCopyright';
import { menuItems, socialButtons } from './constants';
import s from './SiteFooter.scss';
var SiteFooter = function (_a) {
    var className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var theme = useContext(ThemeContext);
    var isDarkTheme = theme === ThemeOptions.DARK;
    return (React.createElement("footer", { className: classnames(s['root'], className), role: "contentinfo" },
        React.createElement("div", { className: s['columns'] },
            React.createElement("div", { className: s['logo-column'] },
                React.createElement(BiLink, { href: URLS.ROOT, title: "DeviantArt - Homepage", biData: BiData({
                        evid: 720,
                        link_name: 'logo',
                    }) },
                    React.createElement(VisuallyHidden, null, "DeviantArt - Homepage"),
                    React.createElement(Logo, { markColor: isDarkTheme ? 'white' : 'black', textColor: isDarkTheme ? 'white' : 'black', size: "tiny" }))),
            React.createElement("div", { className: s['middle-column'] },
                React.createElement("div", { className: s['multi-column'] }, menuItems.map(function (item) { return (React.createElement("div", { key: item.key },
                    React.createElement(BiLink, { href: item.href, title: t(item.key), biData: BiData({
                            evid: 720,
                            link_name: item.name,
                        }) }, t(item.mobileKey && isMobile ? item.mobileKey : item.key)))); }))),
            React.createElement("div", { className: s['social-column'] }, socialButtons.map(function (sb, index) { return (React.createElement(BiLink, { key: index, className: s['social-item'], href: sb.href, title: sb.title, biData: BiData({
                    evid: 720,
                    link_name: sb.name,
                }) },
                React.createElement(VisuallyHidden, null, sb.title),
                React.createElement(sb.icon, { size: IconSize.MEDIUM, disableDefaultColors: true }))); })),
            isMobile && React.createElement(FooterCopyright, { className: s['copyright'] })),
        !isMobile && React.createElement(FooterCopyright, { className: s['copyright'] })));
};
SiteFooter.displayName = 'SiteFooter';
export default React.memo(SiteFooter);
//# sourceMappingURL=SiteFooter.js.map